<template>
  <v-dialog v-model="dialog" width="600px">
    <v-card>
      <v-card-title class="primary white--text text-uppercase" v-if="dialog === true">
        ghi chú KHOẢN {{ titleType }} CỤ THỂ {{ rootPrice.period.title | convertFullDate }}<v-spacer />
        <v-btn dark icon>
          <v-icon @click="closeDialog">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6">
        <v-textarea
          outlined
          full-width
          label="Ghi chú"
          placeholder="Nhập ghi chú cho kỳ này"
          v-model="notes"
          dense
          hide-details
        />
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between align-center" style="width: 100%">
        <v-btn color="gray" class="ma-2 px-8" @click="closeDialog" outlined>Hủy</v-btn>
        <v-btn color="primary" class="elevation-0 px-8" @click="onSave">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      dialog: false,
      notes: '',
      rootPrice: null
    }
  },
  methods: {
    ...mapActions({
      updatePrice: 'tuitonFeePrice/updatePriceIndependent',
      getPrice: 'tuitonFeePrice/getPriceByIdIndepentdent'
    }),
    async openDialog(rootPrice) {
      const existedRootPrice = await this.getPrice(rootPrice.id)
      this.rootPrice = existedRootPrice
      this.notes = existedRootPrice.notes
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.refresh()
    },
    refresh() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSave() {
      const isSuccess = await this.updatePrice({ ...this.rootPrice, price: { notes: this.notes } })
      if (isSuccess) this.closeDialog()
    }
  },
  computed: {
    titleType() {
      return this.$route.meta.title.replace('Chi tiết khoản ', '')
    }
  }
}
</script>
